import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useT } from "@/i18n";
import { Download, X } from "lucide-react";

const DISMISS_KEY = "klus_install_dismissed";
const VISITS_KEY = "klus_visits";

function isStandalone() {
  return (
    window.matchMedia?.("(display-mode: standalone)")?.matches ||
    window.navigator.standalone === true
  );
}

export function InstallBanner() {
  const navigate = useNavigate();
  const { t } = useT();
  const [show, setShow] = useState(false);
  const [canInstall, setCanInstall] = useState(!!window.__pwaPrompt);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(DISMISS_KEY) === "1") return;
    // Count this visit once per tab session.
    if (!sessionStorage.getItem("klus_visit_counted")) {
      const n = parseInt(localStorage.getItem(VISITS_KEY) || "0", 10) + 1;
      localStorage.setItem(VISITS_KEY, String(n));
      sessionStorage.setItem("klus_visit_counted", "1");
    }
    const visits = parseInt(localStorage.getItem(VISITS_KEY) || "0", 10);
    if (visits >= 2) setShow(true);

    const onReady = () => setCanInstall(true);
    const onInstalled = () => setShow(false);
    window.addEventListener("pwaPromptReady", onReady);
    window.addEventListener("pwaInstalled", onInstalled);
    return () => {
      window.removeEventListener("pwaPromptReady", onReady);
      window.removeEventListener("pwaInstalled", onInstalled);
    };
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  const install = async () => {
    const p = window.__pwaPrompt;
    if (p) {
      p.prompt();
      const { outcome } = await p.userChoice;
      window.__pwaPrompt = null;
      if (outcome === "accepted") setShow(false);
    } else {
      navigate("/instalare");
    }
  };

  if (!show) return null;

  return (
    <div data-testid="install-banner"
      className="mb-5 rounded-2xl border border-primary/30 bg-primary/10 backdrop-blur px-4 py-3 flex items-center gap-3 animate-fade-up">
      <div className="w-10 h-10 rounded-xl bg-primary/20 border border-primary/40 flex items-center justify-center shrink-0">
        <Download className="w-5 h-5 text-primary" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-white text-sm font-medium">{t("Instalează aplicația KLUS")}</p>
        <p className="text-slate-400 text-xs">{t("Acces instant de pe ecranul principal, pe tot ecranul.")}</p>
      </div>
      <button onClick={install} data-testid="install-banner-btn"
        className="shrink-0 h-9 px-4 rounded-full bg-primary hover:bg-primary/90 text-white text-sm font-medium transition-colors">
        {canInstall ? t("Instalează") : t("Vezi cum")}
      </button>
      <button onClick={dismiss} data-testid="install-banner-dismiss"
        className="shrink-0 text-slate-500 hover:text-white transition-colors p-1" aria-label={t("Închide")}>
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
